import { VoucherContainer } from '@occ/api-client';

export const mergeVouchers = (vouchers?: VoucherContainer) => {
  return {
    used: [...(vouchers?.usedBonusVouchers ?? []), ...(vouchers?.usedCouponVouchers ?? [])],
    available: [...(vouchers?.bonusVouchers ?? []), ...(vouchers?.couponVouchers ?? [])],
  };
};
